var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marketingList seller-style" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [_vm._v("营销管理")]),
      _c(
        "div",
        { staticClass: "marketingList_main clear relative b_white f14" },
        [
          _c("div", { staticClass: "clear" }, [
            _c("span", { staticClass: "pull-left gray_2 f14" }, [
              _vm._v("营销策略列表")
            ]),
            _c(
              "div",
              { staticClass: "pull-right clear" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "f16",
                    attrs: { plain: "" },
                    on: { click: _vm.toAddMarketingDirect }
                  },
                  [_vm._v(" 手动发放 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "f16",
                    attrs: { type: "primary" },
                    on: { click: _vm.toAddMarketingStrategy }
                  },
                  [
                    _c("span", { staticClass: "f22 lin_25" }, [_vm._v("+")]),
                    _vm._v(" 添加营销策略")
                  ]
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "box30" }),
          _c("div", { staticClass: "marketing_table f14 t_center" }, [
            _vm._m(0),
            _c(
              "table",
              { attrs: { cellpadding: "0", cellspacing: "0", border: "0" } },
              [
                _c(
                  "tbody",
                  _vm._l(_vm.marketingList, function(item) {
                    return _c("tr", { key: item.id }, [
                      _c("td", { attrs: { width: "200" } }, [
                        _vm._v(_vm._s(item.marketingName))
                      ]),
                      _c("td", { attrs: { width: "340" } }, [
                        _vm._v(
                          _vm._s(item.startTimeStr) +
                            " 至 " +
                            _vm._s(item.endTimeStr)
                        )
                      ]),
                      _c("td", { attrs: { width: "120" } }, [
                        _vm._v(_vm._s(item.activeStateCN))
                      ]),
                      _c(
                        "td",
                        { attrs: { width: "" } },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.lookDetail(item)
                                }
                              }
                            },
                            [_vm._v("查看")]
                          ),
                          item.activeState != "HAVE_IN_HAND"
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.delMarketing(item)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ]
            ),
            _c("div", { staticClass: "box30" }),
            _c(
              "div",
              { staticClass: "pages text-right" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "current-page": _vm.pagination.currentPage,
                    "page-sizes": [10, 20, 30],
                    "page-size": _vm.pagination.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.pagination.totalCount
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "营销详情",
            visible: _vm.dialogVisible,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "clear" }, [
            _c("span", { staticClass: "float-left marketing_head f14" }, [
              _vm._v("营销策略名称:")
            ]),
            _c("div", { staticClass: "float-left" }, [
              _c("p", { staticClass: "f14 lin_30" }, [
                _c("span", { staticClass: "pad20_r" }, [
                  _vm._v(_vm._s(_vm.marketingDetail.marketingName))
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "clear" }, [
            _c("span", { staticClass: "float-left marketing_head f14" }, [
              _vm._v("营销客户:")
            ]),
            _c("div", { staticClass: "float-left" }, [
              _c("p", { staticClass: "f14 lin_30" }, [
                _vm.marketingDetail.customerType === "ALL"
                  ? _c("span", { staticClass: "pad20_r" }, [_vm._v("所有人群")])
                  : _vm.marketingDetail.customerType === "GROUPING"
                  ? _c("span", { staticClass: "pad20_r" }, [
                      _vm._v("按客户分组")
                    ])
                  : _vm.marketingDetail.customerType === "CUSTOMER"
                  ? _c("span", { staticClass: "pad20_r" }, [
                      _vm._v("按指定客户")
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm.marketingDetail.customerType === "GROUPING" ||
          _vm.marketingDetail.customerType === "CUSTOMER"
            ? _c("div", { staticClass: "clear" }, [
                _c("span", { staticClass: "float-left marketing_head f14" }, [
                  _vm._v(
                    _vm._s(
                      _vm.marketingDetail.customerType == "GROUPING"
                        ? "客户分组:"
                        : "指定客户:"
                    )
                  )
                ]),
                _c("div", { staticClass: "float-left" }, [
                  _c(
                    "p",
                    { staticClass: "f14 lin_30" },
                    _vm._l(_vm.marketingDetail.customerGroupList, function(
                      group,
                      index
                    ) {
                      return _c(
                        "el-tag",
                        {
                          key: index,
                          staticClass: "pad20_r",
                          staticStyle: { "margin-right": "10px" },
                          attrs: { type: "info" }
                        },
                        [_vm._v("\n            " + _vm._s(group.name))]
                      )
                    }),
                    1
                  )
                ])
              ])
            : _vm._e(),
          _c("div", { staticClass: "clear" }, [
            _c("span", { staticClass: "float-left marketing_head f14" }, [
              _vm._v("营销类型:")
            ]),
            _c("div", { staticClass: "float-left" }, [
              _c("p", { staticClass: "f14 lin_30" }, [
                _c("span", { staticClass: "pad20_r" }, [_vm._v("优惠券")])
              ])
            ])
          ]),
          _c("div", { staticClass: "clear" }, [
            _c("span", { staticClass: "float-left marketing_head f14" }, [
              _vm._v("营销优惠券")
            ]),
            _c("div", { staticClass: "float-left coupon_list" }, [
              _c(
                "ul",
                { staticClass: "clear f12 white" },
                _vm._l(_vm.marketingDetail.coupRegularResList, function(
                  coupon
                ) {
                  return _c("li", { key: coupon.regCode }, [
                    _c("div", { staticClass: "clear coupon_price" }, [
                      _c("span", { staticClass: "float-left f24" }, [
                        _vm._v("￥" + _vm._s(coupon.regVal))
                      ]),
                      _c("div", { staticClass: "float-right t_right" }, [
                        _c("p", [
                          _vm._v("满" + _vm._s(coupon.regKey) + "元可用")
                        ]),
                        coupon.busType === "SHOP"
                          ? _c("p", [_vm._v("全部货品可用")])
                          : _vm._e(),
                        coupon.busType === "GOODS"
                          ? _c("p", [_vm._v("指定货品可用")])
                          : _vm._e(),
                        coupon.busType === "CATE"
                          ? _c("p", [_vm._v("指定分类可用")])
                          : _vm._e()
                      ])
                    ]),
                    _c("p", { staticClass: "t_center" }, [
                      _vm._v(
                        "领取时间：" +
                          _vm._s(coupon.startTimeStr) +
                          "至" +
                          _vm._s(coupon.endTimeStr)
                      )
                    ]),
                    _c("p", { staticClass: "t_center" }, [
                      _vm._v(
                        "使用时间：" +
                          _vm._s(coupon.useStartTimeStr) +
                          "至" +
                          _vm._s(coupon.useEndTimeStr)
                      )
                    ]),
                    _c("div", { staticClass: "clear coupon_num gray_3" }, [
                      _c("span", { staticClass: "float-left" }, [
                        _vm._v("数量："),
                        _c("em", { staticClass: "red" }, [
                          _vm._v(_vm._s(coupon.surplusNum))
                        ])
                      ]),
                      coupon.residueEndDay
                        ? _c("span", { staticClass: "float-right" }, [
                            _vm._v("即将到期")
                          ])
                        : _vm._e()
                    ])
                  ])
                }),
                0
              )
            ])
          ]),
          _c("div", { staticClass: "clear" }, [
            _c("span", { staticClass: "float-left marketing_head f14" }, [
              _vm._v("营销条件:")
            ]),
            _c("div", { staticClass: "float-left" }, [
              _c(
                "p",
                { staticClass: "f14 lin_30" },
                [
                  _vm.marketingDetail.strategyRule !== "TOTAL"
                    ? [
                        _vm.marketingDetail.strategyCondition ===
                        "ORDER_QUANTITY"
                          ? _c("span", { staticClass: "pad20_r" }, [
                              _vm._v(
                                "订单数量满 " +
                                  _vm._s(
                                    _vm.marketingDetail.operatorAmountQuantity
                                  ) +
                                  " 件"
                              )
                            ])
                          : _vm._e(),
                        _vm.marketingDetail.strategyCondition === "ORDER_AMOUNT"
                          ? _c("span", { staticClass: "pad20_r" }, [
                              _vm._v(
                                "订单金额 " +
                                  _vm._s(
                                    _vm.marketingDetail.operatorAmountQuantity
                                  ) +
                                  " 元"
                              )
                            ])
                          : _vm._e()
                      ]
                    : [
                        _vm.marketingDetail.strategyCondition ===
                        "ORDER_QUANTITY"
                          ? _c("span", { staticClass: "pad20_r" }, [
                              _vm._v(
                                "累计商品交易 " +
                                  _vm._s(
                                    _vm.marketingDetail.operatorAmountQuantity
                                  ) +
                                  " 件"
                              )
                            ])
                          : _vm._e(),
                        _vm.marketingDetail.strategyCondition === "ORDER_AMOUNT"
                          ? _c("span", { staticClass: "pad20_r" }, [
                              _vm._v(
                                "累计消费 " +
                                  _vm._s(
                                    _vm.marketingDetail.operatorAmountQuantity
                                  ) +
                                  " 元"
                              )
                            ])
                          : _vm._e()
                      ]
                ],
                2
              )
            ])
          ]),
          _c("div", { staticClass: "clear" }, [
            _c("span", { staticClass: "float-left marketing_head f14" }, [
              _vm._v("营销货品:")
            ]),
            _c("div", { staticClass: "float-left" }, [
              _c("p", { staticClass: "f14 lin_30" }, [
                _vm.marketingDetail.strategyGoods === "ALL"
                  ? _c("span", { staticClass: "pad20_r" }, [_vm._v("全部货品")])
                  : _vm.marketingDetail.strategyGoods === "APPOINT"
                  ? _c("span", { staticClass: "pad20_r" }, [_vm._v("指定货品")])
                  : _vm._e()
              ])
            ])
          ]),
          _vm.marketingDetail.strategyGoods === "APPOINT"
            ? _c("div", { staticClass: "clear" }, [
                _c("span", { staticClass: "float-left marketing_head f14" }, [
                  _vm._v("货品列表")
                ]),
                _c(
                  "div",
                  { staticClass: "float-left" },
                  _vm._l(_vm.marketingDetail.goodsList, function(goods) {
                    return _c(
                      "el-tag",
                      {
                        key: goods.goodsId,
                        staticClass: "pad20_r",
                        staticStyle: { "margin-right": "10px" },
                        attrs: { type: "info" }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(goods.name) + "\n        "
                        )
                      ]
                    )
                  }),
                  1
                )
              ])
            : _vm._e(),
          _c("div", { staticClass: "clear" }, [
            _c("span", { staticClass: "float-left marketing_head f14" }, [
              _vm._v("有效时间:")
            ]),
            _c("div", { staticClass: "float-left" }, [
              _c("p", { staticClass: "f14 lin_30" }, [
                _c("span", { staticClass: "pad20_r" }, [
                  _vm._v(
                    _vm._s(_vm.marketingDetail.startTime) +
                      " 至 " +
                      _vm._s(_vm.marketingDetail.endTime)
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "clear" }, [
            _c("span", { staticClass: "float-left marketing_head f14" }, [
              _vm._v("发放方式:")
            ]),
            _c("div", { staticClass: "float-left" }, [
              _c("p", { staticClass: "f14 lin_30" }, [
                _vm.marketingDetail.marketingGrantType === 1
                  ? _c("span", { staticClass: "pad20_r" }, [
                      _vm._v("支付完成后发放")
                    ])
                  : _vm.marketingDetail.marketingGrantType === 2
                  ? _c("span", { staticClass: "pad20_r" }, [
                      _vm._v("卖家发货后发放")
                    ])
                  : _vm.marketingDetail.marketingGrantType === 3
                  ? _c("span", { staticClass: "pad20_r" }, [
                      _vm._v("确认收货后发放")
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        staticClass: "marketing_table_head",
        attrs: { cellpadding: "0", cellspacing: "0" }
      },
      [
        _c("thead", [
          _c("tr", [
            _c("td", { attrs: { width: "200" } }, [_vm._v("营销策略名称")]),
            _c("td", { attrs: { width: "340" } }, [_vm._v("有效期")]),
            _c("td", { attrs: { width: "120" } }, [_vm._v("状态")]),
            _c("td", { staticClass: "text-center", attrs: { width: "" } }, [
              _c("span", [_vm._v("操作")])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }